const getters = {
  qrCodes: (state) => state.qrCodes,
  isLoading: (state) => state.isLoading,
  error: (state) => state.error,
};

export default getters;
